import React, {useState} from "react";
import {useSelector} from "react-redux";
import Header from "../../main/Header/Header";
import Sidebar from "../../main/Sidebar/Sidebar";
import Landing from "../../main/Landing/Landing";

const InfluencerLayout = ({ children }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    
        const toggleMobileMenu = () => {
            setIsMobileMenuOpen(!isMobileMenuOpen);
        };
    return (
        <div className='w-full h-full'>
            <Header onMenuToggle={toggleMobileMenu}/>
            <div className='flex justify-between h-[90%]'>
                <Sidebar isOpen={isMobileMenuOpen} 
                onClose={() => setIsMobileMenuOpen(false)}/>
                {children}
            </div>

        </div>
    )
};

export default InfluencerLayout;
